import React, { useEffect } from 'react';
// eslint-disable-next-line spire/fenced-imports
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
// eslint-disable-next-line spire/fenced-imports
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';


export interface ApplicationInsightsProps {
  connectionString: string;
  roleName: string;
  corsExcludedDomains: string[],
  children?: React.ReactNode;
}

const AppInsightsComponent : React.FC<ApplicationInsightsProps> = ({ connectionString, roleName, corsExcludedDomains, children }) => {
  const reactPlugin = new ReactPlugin();

  useEffect(() => {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: corsExcludedDomains
      },
    });
    appInsights.loadAppInsights();

    appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
      env.tags = env.tags || [];
      env.tags['ai.cloud.role'] = roleName;
    });

  }, [connectionString]);

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};

export default AppInsightsComponent;